import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface UploadItemMetadata {
  id: string
  caseId: string
  fileName: string
  status: 'pending' | 'uploading' | 'complete' | 'error'
  progress: number
  error?: string
}

interface UploadQueueState {
  items: UploadItemMetadata[]
  processing: boolean
}

const initialState: UploadQueueState = {
  items: [],
  processing: false,
}

const uploadQueueSlice = createSlice({
  name: 'uploadQueue',
  initialState,
  reducers: {
    addToQueue: (state, action: PayloadAction<UploadItemMetadata[]>) => {
      state.items.push(...action.payload)
    },
    updateItemStatus: (
      state,
      action: PayloadAction<{
        id: string
        status: UploadItemMetadata['status']
        progress?: number
        error?: string
      }>
    ) => {
      const { id, status, progress, error } = action.payload
      const item = state.items.find((i) => i.id === id)
      if (item) {
        item.status = status
        if (progress !== undefined) {
          item.progress = progress
        }
        if (error !== undefined) {
          item.error = error
        } else if (status !== 'error') {
          // Clear error when status changes away from error
          delete item.error
        }
      }
    },
    removeFromQueue: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((item) => item.id !== action.payload)
    },
    clearQueue: (state) => {
      state.items = []
      state.processing = false
    },
    setProcessing: (state, action: PayloadAction<boolean>) => {
      state.processing = action.payload
    },
  },
})

export const {
  addToQueue,
  updateItemStatus,
  removeFromQueue,
  clearQueue,
  setProcessing,
} = uploadQueueSlice.actions

export default uploadQueueSlice.reducer

